// Derive MCP-specific card state from a pending action. Pure + tested.
export function mcpCardView(action) {
  const isMcp = action?.action_type === 'mcp_tool_call';
  let payload = action?.action_payload || {};
  if (typeof payload === 'string') { try { payload = JSON.parse(payload); } catch { payload = {}; } }
  const isPaid = !!payload.paid;
  const serverId = payload.serverId || null;
  const toolName = payload.toolName || null;
  const args = isMcp && payload.args && typeof payload.args === 'object' ? payload.args : {};
  const argsText = isMcp && Object.keys(args).length ? JSON.stringify(args, null, 2) : '';
  const conversationId = payload.conversationId || null;
  return {
    isMcp,
    isPaid,
    serverId,
    toolName,
    conversationId,
    args,
    argsText, // Issue 113: the card shows exactly what the tool will receive
    // "Always allow" only for a FREE MCP tool we can actually target.
    showAlwaysAllow: isMcp && !isPaid && !!serverId && !!toolName,
    // "Allow for this chat" additionally needs a conversation to scope to and
    // the SERVER's verdict on whether this tool may be granted at all
    // (spec §4.2 exclusion 3). The client never decides that itself: a legacy
    // card with no `grantable` key simply does not offer the button.
    showAllowForChat: isMcp && !isPaid && !!serverId && !!toolName && !!conversationId && payload.grantable === true,
  };
}
